import EzController from 'controllers/ez-base-controller';

export default class EzRadioButtonToggleController extends EzController {
  static targets = ['button']

  handleOptionClick = (event) => {
    event.preventDefault();

    const option = event.target.closest('.radio-button-toggle__option');
    if (option.classList.contains('is-selected')) return false;

    this.buttonTarget.textContent = option.dataset.dlBtnText;
    this.buttonTarget.dataset.action = option.dataset.buttonActions || '';
    this.buttonTarget.href = option.dataset.buttonHref || '#';

    this.buttonTarget.classList.remove('has-download-icon');
    if (option.dataset.hasDownloadIcon) this.buttonTarget.classList.add('has-download-icon');

    if (option.dataset.buttonModal) {
      this.buttonTarget.dataset.dlAdModalPath = option.dataset.buttonModal;
    } else {
      this.buttonTarget.removeAttribute('data-dl-ad-modal-path');
    }

    if (option.dataset.confirmText) {
      this.buttonTarget.dataset.confirmText = option.dataset.confirmText;
    } else {
      this.buttonTarget.removeAttribute('data-confirm-text');
    }

    this.setIsSelected(option);
    return true;
  }

  setIsSelected = (option) => {
    const selectedOptions = this.element.querySelectorAll('.is-selected');

    selectedOptions.forEach((selectedOption) => {
      selectedOption.classList.remove('is-selected');
      const selectedTitleRadio = selectedOption.querySelector('.radio-button-toggle__option__title input[type=radio]');
      selectedTitleRadio.checked = false;
    });

    option.classList.add('is-selected');
    const titleRadio = option.querySelector('.radio-button-toggle__option__title input[type=radio]');
    titleRadio.checked = true;
  }

  handleSubPlanOptionClick = (event) => {
    event.preventDefault();

    const closedPrice = this.element.querySelector(
      '.radio-button-toggle__option--subs .radio-button-toggle__option__title .radio-button-toggle__option__price',
    );

    const subOption = event.target.closest('.ez-input');

    const subOptionPrice = subOption.querySelector('.radio-button-toggle__option__price').innerHTML;
    closedPrice.innerHTML = subOptionPrice;

    const subsWrapper = event.target.closest('.radio-button-toggle__option__multiple');
    this.setSubOption(subOption, subsWrapper);
  }

  setSubOption = (subOption, subsWrapper) => {
    const checkedSubOption = subsWrapper.querySelector('input[type=radio]:checked');
    if (checkedSubOption) checkedSubOption.checked = false;

    this.buttonTarget.href = subOption.dataset.buttonHref || '#';
    subOption.querySelector('input[type=radio]').checked = true;
  }
}
